export default ({ app }, inject) => {
  // Inject $hello(msg) in Vue, context and store.
  inject(
    'hasContent',
    (value) =>
      (Array.isArray(value) && value.length > 0) ||
      (typeof value === 'object' && Object.keys(value).length > 0)
  )
}
